export default "__VITE_ASSET__BVkLK_4B__"